<script setup>
import { computed, ref } from 'vue'
import { cantidadSalidas } from './fecha'

const props = defineProps({
  conductores: { type: Array, default: () => [] },
  recordadoId: { type: String, default: null },
  congregacion: { type: String, default: null },
})

defineEmits(['elegir'])

// El conductor que ya usó este enlace en este teléfono aparece primero.
const ordenados = computed(() => {
  const recordado = props.conductores.find((c) => c.id === props.recordadoId)
  return recordado
    ? [recordado, ...props.conductores.filter((c) => c.id !== recordado.id)]
    : props.conductores
})

// Por defecto solo se listan los que tienen salidas por informar (y el
// recordado, para que siempre encuentre su nombre); el resto queda detrás de
// "Ver todos los conductores".
const verTodos = ref(false)
const conPendientes = computed(() =>
  ordenados.value.filter((c) => c.salidas.length || c.id === props.recordadoId)
)
const ocultos = computed(() => ordenados.value.length - conPendientes.value.length)
const visibles = computed(() => (verTodos.value ? ordenados.value : conPendientes.value))

const inicial = (name) => (name || '?').trim().charAt(0).toUpperCase()
</script>

<template>
  <div class="mayores-contenido">
    <p class="mayores-saludo">¿Quién sos?</p>
    <p class="campo__ayuda" style="margin-top:0">
      Tocá tu nombre para ver las salidas que tenés que informar{{ congregacion ? ` en ${congregacion}` : '' }}.
    </p>

    <div v-if="!conductores.length" class="mayores-estado">
      <i class="pi pi-users mayores-estado__icono" aria-hidden="true" />
      <p>Todavía no hay conductores cargados para este enlace.</p>
    </div>

    <button
      v-for="c in visibles"
      :key="c.id"
      type="button"
      class="tarjeta-lista tarjeta-lista--clickable mayores-conductor"
      :class="{ 'mayores-conductor--recordado': c.id === recordadoId }"
      @click="$emit('elegir', c.id)"
    >
      <span class="mayores-conductor__inicial" aria-hidden="true">{{ inicial(c.name) }}</span>
      <span class="mayores-conductor__texto">
        <p class="tarjeta-lista__titulo">{{ c.name }}</p>
        <p v-if="c.salidas.length" class="tarjeta-lista__detalle mayores-pendientes">
          <i class="pi pi-clock" aria-hidden="true" /> {{ cantidadSalidas(c.salidas.length) }}
        </p>
        <p v-else class="tarjeta-lista__detalle">
          <i class="pi pi-check" aria-hidden="true" /> Todo informado
        </p>
      </span>
      <i class="pi pi-chevron-right mayores-conductor__flecha" aria-hidden="true" />
    </button>

    <div v-if="conductores.length && !conPendientes.length && !verTodos" class="mayores-estado">
      <i class="pi pi-check-circle mayores-estado__icono" aria-hidden="true" />
      <p>No hay salidas pendientes de informar.</p>
    </div>

    <button
      v-if="ocultos"
      type="button"
      class="boton-secundario mayores-separacion"
      :aria-expanded="verTodos"
      @click="verTodos = !verTodos"
    >
      <template v-if="verTodos">
        <i class="pi pi-chevron-up" aria-hidden="true" /> Ver solo los que tienen que informar
      </template>
      <template v-else>
        <i class="pi pi-users" aria-hidden="true" /> Ver todos los conductores ({{ ocultos }} más)
      </template>
    </button>
  </div>
</template>
